export default __webpack_public_path__ + "static/media/espera.0dd110f5.png";